import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type {
  DataEnvelope,
  EmailSettings,
  SendTestEmailInput,
  SendTestEmailResult,
  UpdateEmailSettingsInput,
} from './types';

export const emailSettingsKey = ['email-settings'] as const;

export function useEmailSettings() {
  return useQuery({
    queryKey: emailSettingsKey,
    queryFn: ({ signal }) =>
      api<DataEnvelope<EmailSettings>>('/email/settings', { signal }).then((r) => r.data),
  });
}

export function useUpdateEmailSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateEmailSettingsInput) =>
      api<DataEnvelope<EmailSettings>>('/email/settings', { method: 'PATCH', body: input }).then(
        (r) => r.data,
      ),
    onSuccess: () => void qc.invalidateQueries({ queryKey: emailSettingsKey }),
  });
}

export function useRegenerateInboundKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api<DataEnvelope<EmailSettings>>('/email/inbound-key/regenerate', { method: 'POST' }).then(
        (r) => r.data,
      ),
    onSuccess: () => void qc.invalidateQueries({ queryKey: emailSettingsKey }),
  });
}

export function useSendTestEmail() {
  return useMutation({
    mutationFn: (input: SendTestEmailInput) =>
      api<DataEnvelope<SendTestEmailResult>>('/email/test', { method: 'POST', body: input }).then(
        (r) => r.data,
      ),
  });
}
